import classNames from 'classnames';
import { SearchBarCampaign } from '@/components/organisms/search-bar/search-bar-campaign';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import styles from './travelportal-campaign-page-header.module.scss';

export interface TravelPortalCampaignPageHeaderProps {
  /** Search settings for filters and search bar */
  searchSettings:
    | Content.Components['SearchSettingsDto']
    | Content.Components['TravelPortalSearchSettingsDto'];
}

const TravelPortalCampaignPageHeader = ({
  searchSettings,
}: TravelPortalCampaignPageHeaderProps) => {
  if (!searchSettings) {
    return null;
  }

  const basicSearchSettings =
    searchSettings as Content.Components['SearchSettingsDto'];

  const travelPortalSearchSettings =
    searchSettings.$type === 'TravelPortalSearchSettingsDto'
      ? (searchSettings as Content.Components['TravelPortalSearchSettingsDto'])
      : undefined;

  return (
    <section className={classNames(styles.component)}>
      <Container>
        <Row className={styles.row}>
          <Column width={{ desktop: 12 }}>
            <div className={styles.searchBarContainer}>
              <SearchBarCampaign
                className={styles.searchBar}
                searchSettings={basicSearchSettings}
                travelPortalSearchSettings={travelPortalSearchSettings}
              />
            </div>
          </Column>
        </Row>
      </Container>
    </section>
  );
};

TravelPortalCampaignPageHeader.displayName = 'TravelPortalCampaignPageHeader';

export default TravelPortalCampaignPageHeader;
